import { FC } from 'react';

import { SingleFilter } from 'components/MultiCreationAuction/VacanciesFiltersPanel/SingleFilter/SingleFilter';
import { VacanciesSearchFilter } from 'components/MultiCreationAuction/VacanciesFiltersPanel/VacancySearchFilter/VacancySearchFilter';

import { VacancyFilterKeys } from 'store/models/multiCreation';
import { useSelector } from 'store/utils';

import styles from 'components/MultiCreationAuction/VacanciesFiltersPanel/VacanciesFiltersPanel.module.less';

export const VacanciesFiltersPanel: FC = () => {
    const filters = useSelector(({ multiCreation }) => multiCreation.filters);

    const filtersKeys = Object.keys(filters) as VacancyFilterKeys[];

    return (
        <div className={styles.wrapper}>
            <VacanciesSearchFilter />
            <div className={styles.filtersWrapper}>
                {filtersKeys.map((filterKey: VacancyFilterKeys) => (
                    <div key={filterKey} className={styles.singleFilter}>
                        <SingleFilter filterKey={filterKey} filterData={filters[filterKey]} />
                    </div>
                ))}
            </div>
        </div>
    );
};
